import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface AgentSidebarProps {
    collapsed: boolean;
    mobileShow: boolean;
    setMobileShow: (show: boolean) => void;
}

const AgentSidebarNav: React.FC<AgentSidebarProps> = ({ collapsed, mobileShow, setMobileShow }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();
    const currentPath = location.pathname;

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        { label: 'Dashboard', path: '/agent-dashboard', icon: 'fa-gauge' },
        { label: 'My Profile', path: '/agent-profile', icon: 'fa-address-card' },
        { label: 'Change Password', path: '/agent-change-password', icon: 'fa-key' },
    ];

    return (
        <aside className={`agent-sidebar ${collapsed ? 'collapsed' : ''} ${mobileShow ? 'show-mobile' : ''}`}>
            <div className="agent-sidebar-header d-flex align-items-center px-4">
                <div className="sidebar-logo">
                    {!collapsed ? (
                        <img src="/logo.png" alt="My Property Guru" style={{ height: '54px', maxWidth: '200px', objectFit: 'contain' }} />
                    ) : (
                        <span className="text-success fw-bold" style={{ fontSize: '1.4rem' }}>G.</span>
                    )}
                </div>
            </div>

            <div className="agent-sidebar-menu">
                <ul>
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <Link
                                to={item.path}
                                className={`agent-sidebar-link ${currentPath === item.path ? 'active' : ''}`}
                                onClick={() => setMobileShow(false)}
                            >
                                <i className={`fa-solid ${item.icon}`}></i>
                                {!collapsed && <span>{item.label}</span>}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="sidebar-footer mt-auto p-3">
                <button
                    onClick={handleLogout}
                    className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center gap-2"
                    style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
                >
                    <i className="fa-solid fa-power-off"></i>
                    {!collapsed && <span>Logout</span>}
                </button>
            </div>
        </aside>
    );
};

export default AgentSidebarNav;
